import { IFeatureFlags } from 'types';

// flags set here override LaunchDarkly
// to initialize launchDarkly flags, see ./launchDarkly
export const production: Partial<IFeatureFlags> = {
  GRAPHQL_BATCH: true,
  KIOSK_REPORT: true,
  SCHEDULING: true,
  MANAGEMENT_LISTS: true,
  MANAGEMENT_LISTS_COST_CODES: true,
  MANAGEMENT_LISTS_EMPLOYEES: true,
  MANAGEMENT_LISTS_PROJECTS: true,
  MANAGEMENT_LISTS_EQUIPMENT: true,
  TIME_ROUNDING: true,
  GROUP_MANAGEMENT: true,
  BREAK_HOURS_REPORT: true,
  TIMESHEETS: true,
  EMPLOYEE_TIMERS: true,
  DASHBOARD: true,
  SETTINGS: true,
  MY_STATUS: true,
  LANDING_PAGES: true,
  SAFETY_SIGN_OFF: true,
  TIME_OFF_REPORT: true,
  MAP_SECTION: true,
  EQUIPMENT_IMPORT: true,
  BULK_PROJECT_COST_CODE_CREATE: true,
  MACHINE_VS_OPERATOR_REPORT: true,
  COMMAND_PALLET: true,
  MANAGEMENT_LISTS_SEARCH: true,
  REACT_BY_DATE_RANGE_ACTIVITY_REPORTS: true,
  SCHEDULE_PRINT: true,
  QUICK_TIME_TEMPLATES: true,
  TIME_LOG_FEED: true,
  PAYROLL_JOURNAL_ENTRIES: true,
  EMPTY_ROUTE: false,

  // under development
  MANAGE_PROJECT_MAP: true,
  MANAGE_EQUIPMENT_MAP: true,
  LABOR_BUDGETS: true,
  HOUR_METER_REPORT: true,
  ACTIVITY_REPORTS_PHASE_3000: true,
  CONVERT_SCHEDULE_TO_TIME_ENTRY: false,
  BUDGET_PERFORMANCE: false,
  PAYROLL_SUBCONTRACTORS: false,
  RECENT_BUDGET_FILTER: false,
};

Object.freeze(production);
